import * as S from "./styles.ts";
import { copyBlockTheme, copyBlockThemeLight } from "./styles.ts";
import { CopyBlock } from "react-code-blocks";
// eslint-disable-next-line import/default
import React from "react";

interface CodeBlockProps {
  code?: number;
  response: any;
  title?: string;
  light?: boolean;
  isCollection?: boolean;
  description?: string;
}

export const CodeBlock = ({
                            code,
                            response,
                            title,
                            light,
                            isCollection,
                            description,
                          }: CodeBlockProps) => {
  const [displayCode, setDisplayCode] = React.useState<string | null>(null);
  let type;
  let statusMessage;
  switch (true) {
    case 100 <= code && code <= 199:
      type = "info";
      break;
    case 200 <= code && code <= 299:
      type = "success";
      break;
    case 300 <= code && code <= 399:
      type = "redirect";
      break;
    case 400 <= code:
      type = "error";
      break;
  }

  switch (code) {
    case 200:
      statusMessage = "OK";
      break;
    case 201:
      statusMessage = "Created";
      break;
    case 202:
      statusMessage = "Accepted";
      break;
    case 204:
      statusMessage = "No Content";
      break;
    case 409:
      statusMessage = "Conflict";
      break;
    case 404:
      statusMessage = "Not Found";
      break;
    case 402:
      statusMessage = "Payment Required";
      break;
    case 401:
      statusMessage = "Unauthorized";
      break;
    case 403:
      statusMessage = "Forbidden";
      break;
    case 400:
      statusMessage = "Bad Request";
      break;
    default:
      statusMessage = "";
  }

  let modifiedRes = isCollection
    ? `{
${response !== "{}" ? `"result": [${response}],` : ""}
"status_code": ${code},
"status_message": "${statusMessage}"
}`
    : `{
${response !== "{}" ? `"result": ${response},` : ""}
"status_code": ${code},
"status_message": "${statusMessage}"
}`;

  if (!code) {
    modifiedRes = response;
  }

  const codeTheme = light ? copyBlockThemeLight : copyBlockTheme;

  return (
    <S.CodeBlockContainer>
      <S.CodeBlockTitle type={type}>
        {title ? title : `${code} Response`}
      </S.CodeBlockTitle>
      {description && (
        <S.CodeBlockDescription>{description}</S.CodeBlockDescription>
      )}
      <CopyBlock
        text={JSON.stringify(JSON.parse(modifiedRes), null, 2) || ""}
        language="json5"
        theme={codeTheme}
        showLineNumbers
        codeBlock
        copied={false}
      />
    </S.CodeBlockContainer>
  );
};
